// extracted by mini-css-extract-plugin
module.exports = {"Back":"Back_Back__Bpfvc","show":"Back_show__1k3tB"};